import {get} from './common';

export const loadSponsorAsync = async locale => {
    let query = `{ sponsoredGames(language: ${locale.toLocaleUpperCase()}) { title logo gamesImageTop gamesImageTopWide gamesImageBottom gamesImageBottomWide webTooltip webImageRight webImageLeft textColor primaryColor }}`;

    let url = `https://cnapp-graph-ql.dmti.cloud?query=${encodeURIComponent(
        query,
    )}`;

    let result = await get(url);

    if (result.data.sponsoredGames) {
        return result.data.sponsoredGames;
    }
    throw new Error('Sponsorship load failed');
};
